import { memo } from "react";
import { cn } from "@discovery/classnames";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { Link } from "../../../../atoms/link";
import { PlaceholderImage } from "../../../../atoms/placeholder-image";
import * as styles from "./styles.css";
import { useDecoratedRoute } from "../../../../../utils/hooks";
export const SquareLogoDesktopCard = memo(({ image, route, decoratorTheme }) => {
    const { decoratedRoute } = useDecoratedRoute(decoratorTheme, route);
    return (React.createElement("div", { className: styles.cardWrapper, id: "#homeCategory" },
        React.createElement(Link, { href: decoratedRoute },
            React.createElement("div", { className: cn(styles.cardThumbnailContainer) },
                React.createElement("div", { className: styles.thumbnailImageContainer },
                    React.createElement("div", { className: styles.thumbnailImageWrapper },
                        React.createElement(PlaceholderImage, null),
                        image && (React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.thumbnailImage, width: 600 }))))))));
});

